$(document).ready(function () {
    pageMain.init();
});


var pageMain = (function () {

    var quick,init, select, tree, tab;



    init = function(){
        select();
        quick();
        tree();
        tab();
    };


    tab = function () {
        

        $(document).on('click','.con-tab li', function (e) {
            e.preventDefault();
            var $tablist = $('.con-tab li');
            var $tabcons = $(".tab-content");

            if($(this).hasClass('disabled')) return;
            if ($(this).hasClass('active')) return;
            var target = $(this).index();
            resetTab($tablist, $tabcons);
            $tablist.eq(target).addClass('active');
            $tabcons.eq(target).show();
        });
    }

    function resetTab($tablist, $tabcons) {
        $tablist.removeClass('active');
        $tabcons.find('li').removeClass('active');
        $tabcons.hide();
    }


     tree = function(){
         var treeItem= null;
        $('.tree-list button').on('click',function(e){
            e.stopPropagation();
        });


             $('body').on('click', function(e){
                 if($('.tree-item').hasClass('active')) {
                     $('.tree-item').removeClass('active');
                     treeItem = null;
                 }
             });
        $('.tree-item').on('click', function(e){
            e.stopPropagation();
            $('.tree-item').removeClass('active');

            if(treeItem == $(this).attr('data-map')){
                treeItem = null;
            }else{
                checkActive($(this).attr('data-map'));
                treeItem = $(this).attr('data-map');
            }
        });
    }

    function checkActive(str){
        switch(str){
            case 'A-1':
                effectActive(['A-1','B-1','B-2']);
                break;
            case 'B-1':
                effectActive(['B-1','C-1','C-3']);
                break;
            case 'B-2':
                effectActive(['B-2','C-2','C-4']);
                break;
            case 'C-1':
                effectActive(['C-1','D-2','D-3']);
                break;
            case 'C-2':
                effectActive(['C-2','D-2','D-3']);
                break;
            case 'C-3':
                effectActive(['C-3','D-1','D-4']);
                break;
            case 'C-4':
                effectActive(['C-4','D-1','D-4']);
                break;
            case 'D-1':
                effectActive(['D-1','E-1','E-2']);
                break;
            case 'D-2':
                effectActive(['D-2','E-3','E-4']);
                break;
            case 'D-3':
                effectActive(['D-3','E-1','E-4']);
                break;
            case 'D-4':
                effectActive(['D-4','E-2','E-3']);
                break;
            case 'E-1':
                effectActive(['E-1']);
                break;
            case 'E-2':
                effectActive(['E-2']);
                break;
            case 'E-3':
                effectActive(['E-3']);
                break;
            case 'E-4':
                effectActive(['E-4']);
                break;
        }
    }

    function effectActive(arr){
        $.each(arr,function(index, item){
            $('[data-map='+item+']').addClass('active');
        })
    }

    // layer tab
    function Tab(el){
        this.el = $(el);
    }

    Tab.prototype  ={
        show :function(){
            var $this = this.el,
                liIndex = $this.index(),
                $div = $this.closest('div'),
                $target = $($this.data('target'));
            this.activate(liIndex, $div);

        },
        activate : function(liIndex, target){
            var $active = target,
                idx = liIndex +1;
            (function next(){
                $active.removeClass();
                $active.addClass('tab0' + idx);
            })();
        }
    };

    $('.tab-wrap').on('click','.tab li',function(e){

        var $this = $(this),
            data = $this.data('tab');
        if(!data) $this.data('tab', data = new Tab(this));
        data.show();

        return false;
    });


    select = function(){
        $(document).on('click', '[data-ui="custom-select"] .opener', function(e){

            var check = $(this).closest('.prevent').hasClass('prevent');
            if(!check) {
                $(this).toggleClass('active');
            }
        });

        $(document).on('click', '[data-ui="custom-select"] li', function(e){
            $(this).parent().prev().html($(this).html()).removeClass('active');
            $(this).parent().next().val($(this).attr('data-value'));
        });

        $(document).on('click', function(e){
            if(!($(e.target).is('[data-ui="custom-select"] .opener') || $(e.target).is('[data-ui="custom-select"] li'))){
                if(!($(e.target).is('[data-ui="custom-select"] .opener strong'))){
                    $('[data-ui="custom-select"] .opener').removeClass('active');
                }
            }
        });
    };

    quick = function(){
        $(window).scroll(function(){
            checkFloat();
        });
    };


    var checkFloat = function(){
        var scltop = $(window).scrollTop();
        if (scltop >= 600) $('.floating-menu').addClass('fix');
        else $('.floating-menu').removeClass('fix');
    };

    return {
        init: function () {
            init();
        },
        resetTab:function(){
            var $div =$('.tab').closest('div');
            $div.removeClass();
            $div.addClass('tab01');
        },
        asideShow:function(num){
            var $aside =$('.floating-menu').eq(num);
            $aside.css('display','block');
        }
    }
})();



// WEBPACK FOOTER //
// ./src/js/index.js